<template>
	<v-card class="mt-2 ml-2" :height="$vuetify.breakpoint.width > 1920 ? '410' : '500' " >
		
		<v-toolbar flat class="depttoolbar">			
			<v-toolbar-title class="body-1">
      			ROOMS
    		</v-toolbar-title>
		</v-toolbar>
		<v-layout row align-center class="pl-2">
			<v-flex>Filter: </v-flex>
			<v-text-field outline 
		  			class="mx-2 mt-2 mb-0 roomfilter caption"
	            	label=""
	            	v-model="roomFilter"
	            	placeholder="filter">
	        </v-text-field>
    	</v-layout>
		<v-list class="pt-0" v-if="roomFilter != ''"
		:style="$vuetify.breakpoint.width > 1920 ? 'height: 400px; overflow: auto;' : 'height: 400px; overflow: auto;'">
			<v-list-tile v-for="(item, index) in items" :key="index"
				@click="getRoom(item, index)"
				class="tightlist"
				:class="{ selected : selectedIndex == index }">
				<div class="caption">{{item.number}}</div>
			</v-list-tile>
		</v-list>
	</v-card>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'RoomQuickList',
data () {
	return {	selectedIndex: 0,
				roomFilter: "",

	}
},

created: function () {
	//console.log("Created Room RoomQuickList")
	this.selectedIndex = this.items.findIndex(item => item.number == this.room.number)
	this.roomFilter = this.room.number.substr(0,2)
},

computed: {
	...mapState({   	buildingRooms: state => state.dv.buildingRooms,	
						room: state => state.dv.room,
						roomBucket: state => state.roomViewer.roomBucket,
				}),

	items: function () { 
			// use roombucket it if exists
			let returnitems = this.roomBucket ? this.roomBucket : this.buildingRooms ? this.buildingRooms : [] 
			
			returnitems = returnitems.filter((room) => room.number.toLowerCase().includes(this.roomFilter.toLowerCase()) )
			return returnitems
		},
},


methods : {
	...mapMutations([ 	'setBuildings',  'setLoadingRoomDetail'
					]),
	...mapActions([ 	'fetchFullRoom', 'setRoom'
					]),

	getRoom: function (item, index) {
		this.selectedIndex = index
		this.setLoadingRoomDetail(true)
		this.fetchFullRoom({bldgAlpha: item.bldgAlpha, number: item.number, noSet: true}).then((data) => { 
			this.setRoom(data) 
			this.setLoadingRoomDetail(false)
		})
	},
},
}

</script>

<style>
.roomfilter .v-input__slot {
	min-height: 0px !important;
}

.roomfilter .v-text-field__slot input {
	margin-top: 0px !important;
	padding: 0px !important;
}

.roomfilter .v-text-field__details {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomQuickList.vue